export default __webpack_public_path__ + "static/media/Quate.d241e411.svg";